import React from 'react';
import Image from 'next/image';

import { IEyebrowFields } from '@/types/contentful';

import { Text } from '../Text';
import cx from 'classnames';

import arrowRight from '@/images/arrow-right.svg';

export function EyebrowHomepage({ text, image, link }: IEyebrowFields) {
  const handleClick = () => {
    if (link) {
      window.location.href = link;
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (link && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      window.location.href = link;
    }
  };

  return (
    <div
      data-testid="eyebrow-link"
      className={cx(
        'bg-[rgba(29,37,44,0.5)] rounded-2xl text-white flex items-center justify-center transition-[background_0.2s_ease,box-shadow_0.2s_ease] p-2 mx-auto tablet:whitespace-nowrap',
        {
          'cursor-pointer hover:bg-[rgba(3, 3, 3, 0.8)] hover:shadow-[0px_4px_40px_rgba(0,0,0,0.24)]':
            link,
          'cursor-auto pr-3': !link,
          'pr-3': link,
        }
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={link ? 'button' : undefined}
      tabIndex={link ? 0 : undefined}
    >
      {image?.fields && (
        <img
          src={image?.fields?.file?.url || undefined}
          alt={image?.fields?.description || ''}
          className="h-10 w-10"
        />
      )}
      <Text
        as="p"
        fontSize="p_0"
        color="white"
        fontWeight="bold"
        paddingLeft="s"
      >
        {text}
      </Text>
      {link && (
        <Image
          src={arrowRight}
          alt={`Navigate to ${text}`}
          className="py-0 px-2 pl-3"
        />
      )}
    </div>
  );
}
